var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data_processed === true)?_c('LineChart',{attrs:{"chart-data":_vm.data_collection,"options":_vm.data_options,"height":null,"width":null}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }